(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zwift-auth-redirect"]) return;
  try {
    
  var el = document.querySelector('.zwift-auth-redirect');
  if (el && el.dataset.redirectUrl) {
    var params = new URLSearchParams(window.location.search);
    var url = el.dataset.redirectUrl;
    var checkoutUrl = params.get('checkout_url');
    var returnUrl = params.get('return_url');
    if (checkoutUrl) {
      try {
        var parsed = new URL(url);
        parsed.searchParams.set('redirect_uri', checkoutUrl);
        url = parsed.href;
      } catch (e) {
        url += (url.includes('?') ? '&' : '?') + 'checkout_url=' + encodeURIComponent(checkoutUrl);
      }
    } else if (returnUrl) {
      try {
        var parsed = new URL(url);
        parsed.searchParams.set('redirect_uri', returnUrl);
        url = parsed.href;
      } catch (e) {
        url += (url.includes('?') ? '&' : '?') + 'return_url=' + encodeURIComponent(returnUrl);
      }
    }
    window.location.replace(url);
  }

  } catch(e) { console.error(e); }
})();
})();
